module.exports = "<div class=\"pageContents\" #pageContents>\n    <div *ngIf=\"titleAsContent\" [innerHTML]=\"title\"></div>\n    <h3 *ngIf=\"!titleAsContent\" class=\"boo-title\" [innerHTML]=\"title\"></h3>\n    <app-content-update-info [lastUpdate]=\"lastUpdate\"></app-content-update-info>\n    <div [innerHTML]=\"contents\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/page-contents/page-contents.component.html
// module id = ./src/app/components/ui/page-contents/page-contents.component.html
// module chunks = main